import styled, { css } from 'styled-components';
import { colorUsage, fontSize, getSpacing, typography } from 'stylesheet';
import { Up } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "ExternalLinkInputstyle__Container",
  componentId: "sc-x57gzf-0"
})(["display:flex;flex-direction:column;justify-content:space-between;width:100%;"]);
var URLInput = styled.input.withConfig({
  displayName: "ExternalLinkInputstyle__URLInput",
  componentId: "sc-x57gzf-1"
})(["", " width:100%;&::placeholder{color:", ";}"], typography.main, colorUsage.placeHolderTextForeground);
var ConfirmButton = styled.button.withConfig({
  displayName: "ExternalLinkInputstyle__ConfirmButton",
  componentId: "sc-x57gzf-2"
})(["display:flex;margin-left:", ";padding:unset;background:none;border:none;"], getSpacing(1));
var ConfirmIcon = styled(Up).withConfig({
  displayName: "ExternalLinkInputstyle__ConfirmIcon",
  componentId: "sc-x57gzf-3"
})(["transform:rotate(90deg);", ""], function (_ref) {
  var disabled = _ref.disabled;
  return disabled === false && css(["cursor:pointer;& circle{fill:", ";}"], colorUsage.iconGradientHoverForeground);
});
var InputContainer = styled.div.withConfig({
  displayName: "ExternalLinkInputstyle__InputContainer",
  componentId: "sc-x57gzf-4"
})(["display:flex;"]);
var AttributesContainer = styled.div.withConfig({
  displayName: "ExternalLinkInputstyle__AttributesContainer",
  componentId: "sc-x57gzf-5"
})(["display:flex;align-items:center;"]);
var AttributeContainer = styled.div.withConfig({
  displayName: "ExternalLinkInputstyle__AttributeContainer",
  componentId: "sc-x57gzf-6"
})(["&:not(:first-child){margin-left:", ";}"], getSpacing(2));
var CheckboxLabel = styled.span.withConfig({
  displayName: "ExternalLinkInputstyle__CheckboxLabel",
  componentId: "sc-x57gzf-7"
})(["font-size:", ";"], fontSize.small);
export { Container, URLInput, CheckboxLabel, ConfirmButton, ConfirmIcon, InputContainer, AttributeContainer, AttributesContainer };